var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled, { css } from "styled-components";
import Flex from "@irati/ui/src/Flex";
export var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
export var Container = styled(function (props) { return React.createElement(Flex, __assign({}, props)); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  ", "\n  span {\n    cursor: pointer;\n  }\n  ", "\n"], ["\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  ",
    "\n  span {\n    cursor: pointer;\n  }\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2_50;
}, function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " 0;\n    &:hover {\n      background: ", ";\n    }\n  "], ["\n    padding: ", " 0;\n    &:hover {\n      background: ", ";\n    }\n  "])), theme.spacing.two, theme.colors.primary2_50);
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-color: transparent;\n  "], ["\n    border-color: transparent;\n  "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
